import React from 'react';
import PropTypes from 'prop-types';
import {CellStyle} from './Table.styled';
export const TableCell = ({children, title, onClick}) => {
	const handleClick = e => {
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	return (
		<CellStyle clickHandled={!!onClick} onClick={handleClick} title={title}>
			{children}
		</CellStyle>
	);
};

TableCell.propTypes = {
	title: PropTypes.string,
	onClick: PropTypes.func,
	children: PropTypes.node,
};
